/* Levels product cards inside Flickity sliders.
   Flickity positions slides absolutely, so each slide is only as tall as its
   own content and a card with a shorter title or description ends up shorter
   than its neighbour. That breaks the bottom-aligned price and add-to-cart row
   (see component-card.css). This measures the tallest slide in each product
   slider and gives every slide that height; the viewport is already sized to
   the tallest slide, so Flickity does not need to re-measure.
   Product tabs (sections/product-tab.liquid) level their own sliders. */
(function () {
  const SLIDER = '.flickity-enabled:not([data-tab-slider])';

  function cellsOf(slider) {
    return slider.querySelectorAll(':scope > .flickity-viewport > .flickity-slider > .grid__item');
  }

  function level(slider) {
    if (!slider.querySelector('.product-card-wrapper')) return;
    const cells = cellsOf(slider);
    if (!cells.length) return;
    cells.forEach((c) => { c.style.height = ''; });
    let max = 0;
    cells.forEach((c) => { max = Math.max(max, c.offsetHeight); });
    if (!max) return;
    cells.forEach((c) => { c.style.height = max + 'px'; });
    slider.dataset.cardsLevelled = 'true';
  }

  // A slider that Flickity tore down (e.g. mobile-only sliders on desktop)
  // goes back to the CSS grid, which stretches cards on its own.
  function release(slider) {
    slider.querySelectorAll('.grid__item').forEach((c) => { c.style.height = ''; });
    delete slider.dataset.cardsLevelled;
  }

  function watch(slider) {
    if (slider._cardLevelObserver) return;
    // Apps (reviews, loyalty badges) inject content into cards after load.
    const observer = new MutationObserver(() => {
      clearTimeout(slider._cardLevelTimer);
      slider._cardLevelTimer = setTimeout(() => level(slider), 100);
    });
    observer.observe(slider, { childList: true, subtree: true });
    slider._cardLevelObserver = observer;
  }

  function levelAll() {
    document.querySelectorAll('[data-cards-levelled]:not(.flickity-enabled)').forEach(release);
    document.querySelectorAll(SLIDER).forEach((slider) => {
      level(slider);
      watch(slider);
    });
  }

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(levelAll, 200);
  });

  // Sections initialise Flickity at different points (DOMContentLoaded, load,
  // after a timeout), so check a few times as the page settles.
  document.addEventListener('DOMContentLoaded', () => setTimeout(levelAll, 100));
  window.addEventListener('load', () => {
    levelAll();
    setTimeout(levelAll, 600);
    setTimeout(levelAll, 1500);
  });
  document.addEventListener('shopify:section:load', () => setTimeout(levelAll, 300));
})();
